import React, { createContext } from 'react';

export const BalanceSheetContext = createContext();
